/**
 * The storage prefix on every PIN: `pin_2026-08-31-123456`.
 *
 * Kept for continuity with PINs already printed on reports. It adds nothing on
 * screen or in a message, so everything a person reads goes through
 * `displayPin`, while copy and search keep the full value.
 */
export const PIN_PREFIX = 'pin_';

/** The PIN as staff read it out, without the storage prefix. */
export function displayPin(pinNo: string): string {
  return pinNo.startsWith(PIN_PREFIX) ? pinNo.slice(PIN_PREFIX.length) : pinNo;
}
